import useMutationApi from 'src/api/useMutationApi';
import {
  ConfirmUploadRequest,
  ConfirmUploadResponse,
} from 'src/types/UserDocuments';

const useConfirmUpload = (documentId: string) => {
  return useMutationApi<ConfirmUploadRequest, ConfirmUploadResponse>({
    endpoint: `core/documents/${documentId}/confirm`,
    method: 'POST',
    showSuccessToast: false,
  });
};

export default useConfirmUpload;
